'use client'

import { FullWidthImageContainer } from '@news12/storybook-news'

import React, { useMemo } from 'react'

import { TopStory } from '../../types'
import extractVideoUrl from '../../utils/extractVideoUrl'
import VideoPlayer from '../utilities/VideoPlayer'

import Image from 'next/image'

const heroImageRatio = 16 / 9

export type HeroProps = {
  story: TopStory
  withAds: boolean
  className?: string
}

const Hero = ({ story, withAds, className }: HeroProps) => {
  const videoUrl = extractVideoUrl(story?.videoFile?.videoUrls)
  const storyCategories = useMemo(() => story?.categories.map(category => category.name), [story])
  if (videoUrl) {
    const { mime, url } = videoUrl

    return (
      <VideoPlayer
        // todo: remove ts-ignore below
        // @ts-ignore
        captions={story?.videoFile?.captions?.['en_US.vtt']}
        className={className}
        overlayText={undefined}
        poster={undefined}
        tags={undefined}
        src={url}
        isLive={story?.videoFile?.isLive}
        type={mime}
        contentfulCategories={storyCategories}
        slug={story?.slug}
        title={story?.title}
        withAds={withAds}
      />
    )
  }

  return (
    story?.heroImage && (
      <FullWidthImageContainer ratio={heroImageRatio} className={className}>
        <Image fill alt={story?.title} data-testid='hero_image' src={story?.heroImage} />
      </FullWidthImageContainer>
    )
  )
}

export default Hero
